export default __webpack_public_path__ + "static/media/signature-placeholder.571da0ce.svg";